import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { MovementReportListResponse } from '@frontend/stock/types';

export class MovementReportClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    static async fetchMovementReport(queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<MovementReportListResponse> {
        return this.apiPaginated<MovementReportListResponse, DefaultQueryParams>(`${this.endpoint}/movements-report`, queryParams);
    }
}
